export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/about-inner-arc.568d56c4-ad50f2.svg";